// フォルダ選択のAJAXとページネーション更新
import { nextTick } from 'vue';

export const FAVORITES_FOLDER_ID = '__favorites__';

export const useFolderNavigation = ({
  items,
  selectedFolderId,
  storeFolderSelection,
  onFolderDataLoaded = null,
  clearKeywordOnNextSelect = null,
}) => {
  const clearSearchKeywordInputs = () => {
    const keywordInputs = document.querySelectorAll('input[name="q"]');
    keywordInputs.forEach((input) => {
      if (input && typeof input.value !== 'undefined') {
        input.value = '';
      }
    });
  };

  const clearFilterInputs = () => {
    const forms = document.querySelectorAll('#simple-search-form, #mobile-search-form');
    forms.forEach((form) => {
      const kindSelect = form.querySelector('select[name="kind"]');
      if (kindSelect) kindSelect.value = '';
      ['date_from', 'date_to'].forEach((name) => {
        const field = form.querySelector('input[name="' + name + '"]');
        if (field) field.value = '';
      });
      Array.from(form.querySelectorAll('input[name="tags[]"]')).forEach((node) =>
        node.remove()
      );
      Array.from(form.querySelectorAll('input[name="ai_tags[]"]')).forEach((node) =>
        node.remove()
      );
      Array.from(form.querySelectorAll('input[name="cad_tags[]"]')).forEach((node) =>
        node.remove()
      );
    });
    document.dispatchEvent(new CustomEvent('clear-dashboard-tags'));
  };

  const updatePagination = (paginationHtml) => {
    const listContainer = document.getElementById('pagination-container-list');
    if (listContainer) listContainer.innerHTML = paginationHtml;

    const gridContainer = document.getElementById('pagination-container-grid');
    if (gridContainer) gridContainer.innerHTML = paginationHtml;
  };

  const selectFolder = async (folderId) => {
    try {
      const isFavoritesFolder = String(folderId ?? '') === FAVORITES_FOLDER_ID;
      // TOP(root仮想フォルダ)はお気に入りと異なり専用の文字列IDを持たず、
      // folderId===null(実質的な"未選択"と同じ値)で表す。
      const isTopFolder = folderId === null;
      storeFolderSelection(folderId);
      const url = new URL(window.location.href);
      url.searchParams.delete('folder_id');
      url.searchParams.delete('page');
      url.searchParams.delete('q');
      url.searchParams.delete('search_scope');
      url.searchParams.delete('tags_present');
      url.searchParams.delete('tags[]');
      url.searchParams.delete('ai_tags_present');
      url.searchParams.delete('ai_tags[]');
      url.searchParams.delete('cad_tags_present');
      url.searchParams.delete('cad_tags[]');
      url.searchParams.delete('kind');
      url.searchParams.delete('date_from');
      url.searchParams.delete('date_to');
      url.searchParams.delete('favorite');
      url.searchParams.delete('top');

      if (clearKeywordOnNextSelect) {
        clearKeywordOnNextSelect.value = false;
      }

      clearSearchKeywordInputs();
      clearFilterInputs();

      const nextUrl = url.toString();

      const response = await axios.get(nextUrl, {
        params: {
          q: '',
          search_scope: isTopFolder ? 'all' : 'folder',
          tags_present: '1',
          ai_tags_present: '1',
          cad_tags_present: '1',
          kind: '',
          date_from: '',
          date_to: '',
          favorite: isFavoritesFolder ? '1' : '0',
          top: isTopFolder ? '1' : '0',
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-Selected-Folder-Id': String(folderId ?? ''),
        }
      });

      if (response.data) {
        items.value = response.data.items || [];
        await nextTick();
        updatePagination(response.data.pagination || '');
        if (typeof onFolderDataLoaded === 'function') {
          onFolderDataLoaded(response.data);
        }

        selectedFolderId.value = folderId;

        try {
          const cleanUrl = new URL(window.location.href);
          cleanUrl.search = '';
          // folder_id はアドレスバーに残す。検索フォーム送信やF5リロード時に
          // resolveRequestedFolderId() がセッションの汚染値へフォールバックするのを防ぐため。
          if (!isFavoritesFolder && folderId !== null && folderId !== undefined && folderId !== '') {
            cleanUrl.searchParams.set('folder_id', String(folderId));
          }
          window.history.replaceState(window.history.state, '', cleanUrl.toString());
        } catch (e) {
          // noop
        }
      }
    } catch (error) {
      console.error('Folder selection failed:', error);
    }
  };

  return {
    selectFolder,
  };
};
